module.exports = __webpack_public_path__ + "img/16.d3f819ab.png";